<template>
  <svg aria-hidden="true" ...attributes width="24" height="24" fill="none" viewBox="0 0 24 24">
    <rect
      width="14.5"
      height="14.5"
      x="4.75"
      y="4.75"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
      rx="2"
    ></rect>
    <path
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
      d="M8.75 10.75L11.25 13L8.75 15.25"
    ></path>
  </svg>
</template>
